import Handler from '@/core/domain/usecase/handler';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { AlertType } from '../../domain/model/alert';

export interface CreateAlertTypeRepository {
  (data: object): Promise<AlertType>
}

const createAlertTypeRepository = (axios: AxiosInstance): CreateAlertTypeRepository => async (data: object) => {
  try {
    const response: AxiosResponse = await axios.post(`/alert-type`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createAlertTypeRepository

